export const BLOCK_WIDTH = 3
export const BLOCK_HEIGHT = 3
export const TRACK_GAP = 1
export const FULL_WIDTH = BLOCK_WIDTH + TRACK_GAP
export const FULL_HEIGHT = BLOCK_HEIGHT + TRACK_GAP

export const MATRIX_CELL_SIZE = 68
export const TRACK_PER_TARGET = 6
export const TRACK_SIZE = MATRIX_CELL_SIZE / TRACK_PER_TARGET
const cellAmountRaw =
  (((document.body.clientWidth - 8 * 2) / MATRIX_CELL_SIZE) | 0) - 1
export const MATRIX_CELL_AMOUNT_ROW =
  cellAmountRaw % FULL_WIDTH === 0 ? cellAmountRaw + TRACK_GAP : cellAmountRaw
export const TRACK_AMOUNT_ROW = MATRIX_CELL_AMOUNT_ROW * TRACK_PER_TARGET

export const BLOCK_AMOUNT_IN_ROW = (MATRIX_CELL_AMOUNT_ROW / FULL_WIDTH) | 0

export const NODE_TEXT_MAX = 19
